import { render } from "./SidenavItem.vue?vue&type=template&id=017f45c4&scoped=true&ts=true"
import script from "./SidenavItem.vue?vue&type=script&lang=ts"
export * from "./SidenavItem.vue?vue&type=script&lang=ts"

import "./SidenavItem.vue?vue&type=style&index=0&id=017f45c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-017f45c4"]])

export default __exports__